import { render, staticRenderFns } from "./BoostersInTargetGroup.vue?vue&type=template&id=3b4bbc46"
import script from "./BoostersInTargetGroup.vue?vue&type=script&lang=js"
export * from "./BoostersInTargetGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports